import { EventEmitter, Injectable } from '@angular/core';
import { WorkflowVertex } from 'component.workflow.core';
import {
  WorkflowGraphDispatcherActionType as ActionType,
  WorkflowGraphDispatcherService
} from './workflow-graph-dispatcher.service';

@Injectable()
export class WorkflowGraphSelectionService {

  selectionUpdated = new EventEmitter<WorkflowVertex[]>();
  verticesSelected: WorkflowVertex[] = [];

  offsetLocations: any[] = [];
  dragStartLocations: any[] = [];

  constructor(protected dispatcherService: WorkflowGraphDispatcherService) {
  }

  updateSelection(updatedList: WorkflowVertex[]) {
    this.verticesSelected = updatedList;
    this.selectionUpdated.emit(updatedList);

    this.offsetLocations = [];
    this.dragStartLocations = [];
  }

  isSelected(vertex: WorkflowVertex): boolean {
    return this.verticesSelected.findIndex(v => vertex === v) >= 0;
  }

  selectionDragMoved(location: any) {

    let idx = 0;
    for (const vertex of this.verticesSelected) {
      const offset = this.offsetLocations[idx];
      vertex.x = offset.x + location.dx;
      vertex.y = offset.y + location.dy;

      this.dispatcherService.dispatchAction(ActionType.VertexMoving, this, vertex);
      idx++;
    }
  }

  selectionDragFinished() {
    for (const vertex of this.verticesSelected) {
      this.dispatcherService.dispatchAction(ActionType.VertexMoved, this, vertex);
    }
  }

  hasVerticesSelected(): boolean {
    return this.verticesSelected.length > 0;
  }

  updateSelectionState(vertexList: WorkflowVertex[]): WorkflowVertex[] {
    const updatedList = [...this.verticesSelected];

    for (const vertex of vertexList) {
      const idx = updatedList.indexOf(vertex);

      if (idx < 0) {
        // Its not in the list
        updatedList.push(vertex);
      } else {
        updatedList.splice(idx, 1);
      }
    }

    this.updateSelection(updatedList);

    return updatedList;
  }

  selectionDragActivated(event: MouseEvent, origin: any, zoom: number) {
    this.offsetLocations = this.verticesSelected.map(vertex => ({x: +vertex.x, y: +vertex.y}));

    const offsetDiff = {
      x: origin.x - event.clientX,
      y: origin.y - event.clientY
    };

    this.dragStartLocations = this.verticesSelected.map(vertex => {
      return {
        x: vertex.x - offsetDiff.x,
        y: vertex.y - offsetDiff.y
      };
    });
  }

  addToSelection(vertex: WorkflowVertex) {
    if (this.isSelected(vertex)) {
      return;
    }

    this.updateSelection([...this.verticesSelected, vertex]);
  }

  removeFromSelection(vertex: WorkflowVertex) {
    const idx = this.verticesSelected.indexOf(vertex);

    if (idx < 0) {
      return;
    }

    const updatedList = [...this.verticesSelected];
    updatedList.splice(idx, 1);

    this.updateSelection(updatedList);
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/workflow-graph-selection.service.ts